import React from 'react';
import LocationComponent from 'onboard/components/LocationComponent';

// Title/description now render in SystemModal's own header (see onboard/modals/index.js) —
// this used to duplicate them locally inside a PaperBlock nested in the legacy Modal's paper.
const LocationModal = () => <LocationComponent />;

export default LocationModal;
